import { defineMessages } from "react-intl";

export const messages = defineMessages({
    profileLogout: {
        id: "fastshift.navigation.profile.logout",
        defaultMessage: "Logout",
        description: "Label for the logout link in the profile section"
    },
    accountSectionTitle: {
        id: "fastshift.navigation.profile.account-section-title",
        defaultMessage: "ACCOUNT",
        description: "Title for the account section in the profile navigation"
    }
});
